import { useState, useCallback } from 'react'
import MojeSzkoleniaService from '@/services/MojeSzkoleniaService'

export default function useMyTrainingsData() {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [loadingMore, setLoadingMore] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)
	const [hasMore, setHasMore] = useState(false)
	const [filters, setFilters] = useState({})
	const [sortColumn, setSortColumn] = useState('data_rozpoczecia')
	const [sortDirection, setSortDirection] = useState('desc')
	const [limit, setLimit] = useState(50)

	const loadData = useCallback(async () => {
		setLoadingMore(prevLoadingMore => {
			if (!prevLoadingMore) setLoading(true)
			return prevLoadingMore
		})
		setError(null)

		const searchText = (filters.searchText || '').trim()
		const requestOptions = {
			limit,
			sortColumn,
			sortDirection,
			filters: {
				status: filters.status || null,
				placowkaId: filters.placowkaId || null,
			},
		}
		const result = searchText
			? await MojeSzkoleniaService.search(searchText, requestOptions)
			: await MojeSzkoleniaService.getAll(requestOptions)

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
			setHasMore(false)
		} else {
			setData(result.data)
			setTotalCount(result.totalCount)
			setHasMore(result.hasMore)
		}

		setLoading(false)
		setLoadingMore(false)
	}, [limit, sortColumn, sortDirection, filters])

	const handleLoadMore = useCallback(() => {
		if (hasMore && !loadingMore) {
			setLimit(prev => prev + 50)
			setLoadingMore(true)
		}
	}, [hasMore, loadingMore])

	const setSorting = useCallback((column, direction) => {
		setSortColumn(column)
		setSortDirection(direction)
	}, [])

	const updateFilters = useCallback(newFilters => {
		setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	return {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery: filters.searchText || '',
		clearError,
	}
}
